function PostDetails(){
    return(
        <>
            <div className="page-banner">
            <div className="container">
                <div className="page-banner-content">
                    <div className="banner-inner">
                        <h2>Blog</h2>
                        <div className="page-route">
                            <a href="">Home </a>
                            <p> / Blog </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* // ==========================post details======================= */}
        <div className="blog-details-page cpy-8">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mb-5">
                        <div className="blog-details-content">
                            <h1 className="post-title">I Believe everyone can be a designer as long they love to create design</h1>
                            <div className="post-meta">
                                <div className="post-inview ps-0">
                                    <h5>DESIGNER INTERVIEW</h5>
                                    <p>AUGUST CHAPTER</p>
                                </div>
                                <div className="post-date">
                                    <div className="post-inview br-right">
                                        <h5>WRITER</h5>
                                        <p>DWINAWAN</p>
                                    </div>
                                    <div className="post-inview">
                                        <h5>DATE</h5>
                                        <p>AUGUST 11, 2021</p>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-details-inner">
                                <div className="blog-details-img">
                                    <img src="assets/img/collection/1.jpg" alt="image not found"/>
                                </div>
                                <div className="blog-details-text">
                                    <h3 className="mt-3">What is the most fun thing to become a designer?</h3>
                                    <div className="blog-details-text-inner">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Cupidatat non
                                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="post-inner-img">
                                            <img src="assets/img/inner/19.png" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <div className="post-inner-img">
                                            <img src="assets/img/inner/20.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-details-text">
                                    <h3 className="mt-3">Simple way to sharin</h3>
                                    <div className="blog-details-text-inner">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Cupidatat non
                                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="post-inner-img">
                                            <img src="assets/img/banner/3.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-details-text">
                                    <h3 className="mt-3">Simple way to sharin</h3>
                                    <div className="blog-details-text-inner">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Cupidatat non
                                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    </div>
                                </div>

                                <div className="share-bar">
                                    <div className="this-post-tag">
                                        <h5>TAGS:</h5>
                                        <ul className="tags">
                                            <li><a href="" className="tag-link">Bitcoin</a></li>
                                            <li><a href="" className="tag-link">Token</a></li>
                                            <li><a href="" className="tag-link">Wallet</a></li>
                                        </ul>
                                    </div>
                                    <div className="share-area">
                                        <h5>SHARE:</h5>
                                        <ul className="share-social">
                                            <li><a href=""><i class="icofont-facebook"></i></a></li>
                                            <li><a href=""><i class="icofont-twitter"></i></a></li>
                                            <li><a href=""><i class="icofont-twitch"></i></a></li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="blog-details-comment">
                            <div className="blog-details-comment-inner">
                                <div className="blog-details-comment-title">
                                    <h3>Leave a comment</h3>
                                    <div className="comment-form">
                                        <form action="">
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <input type="text" className="form-control" placeholder="Your Name"/>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <input type="text" className="form-control" placeholder="Your Name"/>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <textarea name="" className="form-control" id="" cols="30" rows="5"></textarea>
                                                </div>
                                            </div>
                                            <button className="custom-btn"><span>Send comment</span></button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                    <div className="col-lg-4 ">

                        <div className="filter-by-tag">
                            <h3>Recent post</h3>
                            <ul className="recent-post-ul">
                                <li>
                                    <div class="author-info"><img src="assets/img/inner/7.jpg" alt="" class="author-img"/>
                                        <div class="author-name-type">
                                            <a href="" class="creator-profile">6 Make Mobile Website Faster</a>
                                            <p class="author-type">Lorem ipsum dolor sit amer....</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="author-info"><img src="assets/img/inner/7.jpg" alt="" class="author-img"/>
                                        <div class="author-name-type">
                                            <a href="" class="creator-profile">6 Make Mobile Website Faster</a>
                                            <p class="author-type">Lorem ipsum dolor sit amer....</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="author-info"><img src="assets/img/inner/7.jpg" alt="" class="author-img"/>
                                        <div class="author-name-type">
                                            <a href="" class="creator-profile">6 Make Mobile Website Faster</a>
                                            <p class="author-type">Lorem ipsum dolor sit amer....</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="author-info"><img src="assets/img/inner/7.jpg" alt="" class="author-img"/>
                                        <div class="author-name-type">
                                            <a href="" class="creator-profile">6 Make Mobile Website Faster</a>
                                            <p class="author-type">Lorem ipsum dolor sit amer....</p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="author-info"><img src="assets/img/inner/7.jpg" alt="" class="author-img"/>
                                        <div class="author-name-type">
                                            <a href="" class="creator-profile">6 Make Mobile Website Faster</a>
                                            <p class="author-type">Lorem ipsum dolor sit amer....</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    <div className="filter-by-tag mt-3">
                                <h3>Popular Tag</h3>
                                <ul className="tag-ul mt-2">
                                    <li className="tag-name">
                                        <a href="" className="tag-link">  <span>Listings</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"> <span>Like</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Purchases</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Sales</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Transfer</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Burns</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Bids</span></a>
                                    </li>
                                    <li className="tag-name">
                                        <a href="" className="tag-link"><span>Followings</span></a>
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        </>

        // ==========================post details=======================

    );
}
export default PostDetails;